<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <TLogo />
          <h2 class="text-h4 mt-15 text-center">Entrar</h2>
          <v-form class="mt-10">
            <v-text-field
              name="email"
              label="E-mail"
              type="text"
              placeholder="Seu email"
              outlined
              single-line
              v-model="loginForm.email"
              error-messages="O e-mail é obrigatório"
              :verifiyError="$v.loginForm.email.$error"
              @input="$v.loginForm.$touch()"
            />
            <v-text-field
              class="mb-0 pb-0"
              name="password"
              label="Senha"
              type="password"
              placeholder="Sua senha"
              v-model="loginForm.password"
              single-line
              outlined
              error-messages="A senha é obrigatória"
              @input="$v.loginForm.$touch()"
            />
            <a href="/recuperar-senha">Recuperar senha</a>
            <v-btn
              @click="handleSubmit()"
              color="#F2994A"
              depressed
              class="mt-10 text--white"
              elevation="5"
              block
              large
              :loading="loading"
            >
              ENTRAR
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import notification from '@/support/mixins/notifications.mixin'
import { mapActions } from 'vuex'
import formErrors from '@/support/mixins/form-errors.mixin'
import { required, email } from 'vuelidate/lib/validators'
import TLogo from '@/components/TLogo'

export default {
  name: 'AuthContainer',
  components: {
    TLogo
  },
  mixins: [notification, formErrors],
  data: () => ({
    loading: false,
    loginForm: {
      email: '',
      password: ''
    }
  }),
  methods: {
    ...mapActions('Login', ['login']),
    async handleSubmit () {
      this.loading = true
      const fields = [this.$v.loginForm]
      try {
        await this.verifyErrorsForm(fields)
        this.loading = true
        try {
          await this.login({ ...this.loginForm })
          this.loading = false
          this.$router.push('home')
        } catch (err) {
          this.errorMsg(
            'Usuário',
              `${err.response.data.message}`,
              'topCenter'
          )
        } finally {
          this.loading = false
        }
      } catch (error) {
        this.errorMsg(
          'Usuário',
          'Não foi possivel realizar o login, verifique os erros no formulário',
          'topCenter'
        )
      } finally {
        this.loading = false
      }
    }
  },
  validations: {
    loginForm: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  }
}
</script>

<style>
.v-btn__content {
  color: white;
  font-weight: bold;
  font-size: 13px;
}
</style>
